import { render, staticRenderFns } from "./GlobalLayer.vue?vue&type=template&id=2062596e&scoped=true&"
import script from "./GlobalLayer.vue?vue&type=script&lang=js&"
export * from "./GlobalLayer.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLayer.vue?vue&type=style&index=0&id=2062596e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2062596e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCheckbox,VDivider})
